import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { decrement, increment, reset, incrementByAmount } from "./counterSlice";

import { useState } from "react";

const Counter = () => {
  const count = useSelector((state) => state.counter.count);
  const dispatch = useDispatch();

  const [incrementAmount, setIncrementAmount] = useState(0);

  const addValue = Number(incrementAmount) || 0;

  const resetAll = () => {
    setIncrementAmount(0);
    dispatch(reset());
  };

  return (
    <section>
      <div className="app__counter-container">
        <p className="p-text">{count}</p>
        <div className="app__counter-buttons">
          <button
            className="app__counter-button"
            onClick={() => dispatch(decrement())}
          >
            -
          </button>
          <button
            className="app__counter-button"
            onClick={() => dispatch(increment())}
          >
            +
          </button>
        </div>

        <input
          type="text"
          className="app__counter-input"
          value={incrementAmount}
          onChange={(e) => setIncrementAmount(e.target.value)}
        />

        <div className="app__counter-buttons">
          <button
            className="app__counter-button"
            onClick={() => dispatch(incrementByAmount(addValue))}
          >
            Add Amount
          </button>
          <button className="app__counter-button" onClick={resetAll}>
            {" "}
            Reset{" "}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Counter;
